import { render, staticRenderFns } from "./BrushRecord.vue?vue&type=template&id=3aad23a4&scoped=true"
import script from "./BrushRecord.vue?vue&type=script&lang=js"
export * from "./BrushRecord.vue?vue&type=script&lang=js"
import style0 from "./BrushRecord.vue?vue&type=style&index=0&id=3aad23a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aad23a4",
  null
  
)

export default component.exports